export default {
  IGNORE: -1,
  FALSE: 0,
  TRUE: 1
};
